module.exports = __webpack_public_path__ + "static/media/kingsarcade3.23c44b8e.jpg";